import { contractShowTabs } from "../../js-data/contract-tab-groups";
import {
  deleteContract,
  getContract,
  getContracts,
  storeContract,
  updateContract
} from "../../api-helpers/contracts/api-contracts";
import ScopeOfWork from "./module-scope-of-work";
import Procedures from "./module-procedures";
import Plans from "./module-plans";
import Procurements from "./module-procurements";
import JobTracking from "./module-job-tracking";
import WorkOrders from "./module-work-orders";
import Notes from "./module-notes";

export default {
  modules: {
    ScopeOfWork,
    Procedures,
    Plans,
    Procurements,
    JobTracking,
    WorkOrders,
    Notes
  },
  state: {
    isGettingContracts: false,
    isGettingContract: false,
    contracts: null,
    isStoringContract: false,
    isUpdatingContract: false,
    isDeletingContract: false,
    contract: null,
    showTabs: contractShowTabs
  },
  mutations: {
    setIsGettingContracts(state, bool) {
      state.isGettingContracts = bool;
    },
    setIsGettingContract(state, bool) {
      state.isGettingContract = bool;
    },
    setContracts(state, contracts) {
      state.contracts = contracts;
    },
    setIsStoringContract(state, bool) {
      state.isStoringContract = bool;
    },
    setIsUpdatingContract(state, bool) {
      state.isUpdatingContract = bool;
    },
    setIsDeletingContract(state, bool) {
      state.isDeletingContract = bool;
    },
    setContract(state, contract) {
      state.contract = contract;
    },
    setContractShowTabsCounts(state, counts) {
      state.showTabs = state.showTabs.map(tab => {
        if (counts[tab.slug]) {
          tab.count = counts[tab.slug];
        }
        return tab;
      });
    }
  },
  actions: {
    async getContracts({ commit, state }, projectId = undefined) {
      let contracts = state.contracts;
      if (!state.isGettingContracts) {
        commit("setIsGettingContracts", true);

        contracts = await getContracts(projectId);
        commit("setContracts", contracts);

        commit("setIsGettingContracts", false);
      }
      return contracts;
    },
    async getContract({ commit, state }, contractId) {
      let contractAndCounts;
      if (!state.isGettingContracts) {
        commit("setIsGettingContract", true);

        contractAndCounts = await getContract(contractId);
        commit("setContract", contractAndCounts.contract);
        commit("setContractShowTabsCounts", contractAndCounts.counts);

        commit("setIsGettingContract", false);
      }
      return contractAndCounts;
    },
    async storeContract({ commit, state }, contract) {
      let response;
      if (!state.isStoringContract) {
        commit("setIsStoringContract", true);

        response = await storeContract(contract);

        commit("setIsStoringContract", false);
      }
      return response;
    },
    async updateContract({ commit, state, dispatch }, contract) {
      let response;
      if (!state.isStoringContract) {
        commit("setIsUpdatingContract", true);

        response = await updateContract(contract);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Contract updated successfully.",
          errorText: "An error occurred while attempting to update Contract.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            if (contract.isShowView) {
              dispatch("getContract", contract.id);
            } else {
              dispatch("getProject", contract.project_id);
            }
          }
        });

        commit("setIsUpdatingContract", false);
      }
      return response;
    },
    async deleteContract({ commit, state }, project) {
      let response;
      if (!state.isDeletingContract) {
        commit("setIsDeletingContract", true);

        response = await deleteContract(project);

        commit("setIsDeletingContract", false);
      }
      return response;
    }
  }
};
